/* oxlint-disable react/jsx-no-useless-fragment */
import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';
import { Close } from './parts/Close';

import * as styles from './styles.css';

interface IProps {
  showTooltip: boolean;
  onClose(): void;
  description: string;
}

export function FlatViewOrderTooltip({ showTooltip, onClose, description }: IProps) {
  return (
    <>
      {!showTooltip ? null : (
        <div className={styles['container']}>
          <div className={styles['wrapper']}>
            <div className={styles['tooltip']}>
              <div className={styles['calendar']} />
              <InlineText2 fontWeight="bold">{description}</InlineText2>
              <Close onClick={onClose} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
